export enum UserType {
  Florist = 'Florist',
  Internal = 'Internal',
}

export type UserTutorialResponse = {
  id: string;
  createdAt: string;
  userId: string;
  userType: UserType;
  seenTutorialsList: string[];
};

export type MarkTutorialSeenRequest = {
  userType: UserType;
  userId: string;
  tutorialId: string;
};
